<div class="layout-dashboard card">
    <div class="" *ngIf="order">
        <div
            class="flex flex-column align-items-start mb-2 border-bottom-1 surface-border"
        >
            <div #title class="flex align-items-center">
                <p-button
                    icon="pi pi-arrow-left"
                    [rounded]="true"
                    [raised]="true"
                    class="mr-2"
                    [text]="true"
                    severity="danger"
                    [routerLink]="'/home/orders'"
                />
                <h4>{{ "Order Detail" | translate }}</h4>
            </div>
            <div *ngIf="order.status === 'OPEN'" class="mt-2">
                <div
                    class="mb-4 flex align-items-center gap-3 justify-content-start"
                >
                    <span
                        class="p-card-title text-800 mb-0 text-sm font-semibold"
                        >{{ "This invoice is pending payment" | translate }} -
                        {{ "Ordered on" | translate }}
                        {{ order.orderDate | date : "medium" }}</span
                    >
                </div>
            </div>
            <div
                *ngIf="order.status === 'WAITING_PAYMENT_VERIFICATION'"
                class="mt-2"
            >
                <div
                    class="mb-4 flex align-items-center gap-3 justify-content-start"
                >
                    <span
                        class="p-card-title text-800 mb-0 text-sm font-semibold"
                    >
                        {{ "Your payment submitted on" | translate }}
                        {{ order.orderDate | date : "medium" }}
                        {{ "is pending verification" | translate }}</span
                    >
                </div>
            </div>
        </div>
        <ul class="list-none p-0 m-0" *ngIf="order.orderItems">
            <li
                *ngFor="let item of order.orderItems"
                class="flex flex-column md:flex-row py-2 border-bottom-1 surface-border md:align-items-center"
            >
                <div class="flex-auto py-5 md:pl-5">
                    <div
                        class="flex flex-wrap align-items-start sm:align-items-center sm:flex-row sm:justify-content-between surface-border"
                    >
                        <div class="w-full sm:w-6 flex flex-column">
                            <span class="text-900 text-xl font-medium mb-3"
                                >{{ item.selectedOption.packageName }} ({{
                                    item.selectedOption.providerName
                                }})</span
                            >
                            <span class="inline-flex align-items-center mb-3">
                                <i class="pi pi-wallet text-700 mr-2"></i>
                                <span class="font-medium"
                                    >{{ "Annual premium at" | translate }}
                                    {{
                                        item.selectedOption.annualPremium
                                            | currency : "MZN" + " "
                                    }}</span
                                >
                            </span>
                            <span class="inline-flex align-items-center mb-3">
                                <i class="pi pi-car text-700 mr-2"></i>
                                <span class="text-700 mr-2">
                                    {{ item.vehicle.model.make.name }} /
                                    {{ item.vehicle.model.name }} ({{
                                        item.vehicle.yearOfManufacture
                                    }})
                                </span>
                            </span>
                            <span class="inline-flex align-items-center mb-3">
                                <i class="pi pi-file-o text-700 mr-2"></i>
                                <span class="text-700 mr-2"
                                    >{{ "Registration Number" | translate }}
                                    {{ item.vehicle.registrationNumber }}</span
                                >
                            </span>
                        </div>
                        <div
                            class="w-full sm:w-6 flex align-items-end justify-content-between mt-3 sm:mt-0"
                        >
                            <div
                                class="flex flex-column sm:align-items-end w-full"
                            >
                                <span
                                    class="text-900 text-xl font-medium mb-2 sm:mb-3"
                                    >{{
                                        item.selectedOption.premiumDue
                                            | currency : "MZN" + " "
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div class="flex">
            <div class="w-12rem hidden md:block"></div>
            <ul
                class="list-none py-0 pr-0 pl-0 md:pl-5 mt-4 mx-0 mb-0 flex-auto"
            >
                <li class="flex justify-content-between surface-border mb-4">
                    <span class="text-xl text-900 font-bold text-3xl">{{
                        "TOTAL" | translate
                    }}</span>
                    <span
                        class="text-xl text-900 font-bold text-3xl"
                        *ngIf="order"
                        >{{ order.total | currency : "MZN" + " " }}</span
                    >
                </li>
            </ul>
        </div>
        <div
            class="flex w-full mt-1 gap-2 align-items-start justify-content-end"
        >
            <p-button
                icon="pi pi-credit-card"
                pRipple
                *ngIf="isPayable()"
                (onClick)="checkout()"
                class="ml-2"
                [label]="'PAY_NOW' | translate"
                severity="secondary"
            />
        </div>
    </div>
</div>
